import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isOnlyIcon?: boolean }>()(
  (theme, { isOnlyIcon }) => ({
    awslogo: {
      width: theme.spacing(5.875),
      height: theme.spacing(3.5),
      objectFit: 'contain',
      ...(!isOnlyIcon ? { margin: theme.spacing(0.09, 2.5, 0, 0) } : {}),
    },
    azurelogo: {
      width: theme.spacing(4.125),
      height: theme.spacing(4.125),
      objectFit: 'contain',
      ...(!isOnlyIcon
        ? { marginRight: theme.spacing(2.875), marginLeft: theme.spacing(1.75) }
        : {}),
    },
    gcpLogo: {
      width: theme.spacing(7),
      height: theme.spacing(4.375),
      objectFit: 'contain',
      ...(!isOnlyIcon ? { marginRight: theme.spacing(1.625) } : {}),
    },
    productNameContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      lineHeight: '0.8px',
    },
    sellerProductName: {
      fontSize: '22px',
      color: theme.palette.flyoutText.main,
      fontWeight: 600,
      margin: theme.spacing(2.5, 1.23, 2.5, 0),
      textAlign: 'left',
    },
  })
)
